import React, { Component } from 'react';
import { Button, Form, Divider, TextArea } from 'semantic-ui-react';

import { getFullAd } from '../../fbApi/Ad';
import { compareAds, reportAd } from './AdComparerService';
import './CompareAds.css';

class CompareAds extends Component {
  state = {
    result: '',
    token: this.props.getFbToken(),
    form: {
      firstAd: '',
      secondAd: ''
    },
    logFirstAd: '',
    logSecondAd: ''
  };

  componentDidMount() {
    this.props.setSectionTitle('Compare Ads POC');
    this.props.saveGTMEvent('Compare Ads POC', 'Alexia');
  }

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  handleCompareAds = async () => {
    this.setState({ result: '', logFirstAd: '', logSecondAd: '' });
    const { firstAd, secondAd } = this.state.form;
    const { token } = this.state;

    if (!firstAd || !secondAd) {
      this.setState({ result: 'You must enter the ads to be compared' });
      return;
    }

    const ad1 = await getFullAd(firstAd, token);
    const ad2 = await getFullAd(secondAd, token);

    if (ad1.error || ad2.error) {
      this.setState({ result: 'There was an error getting the ads' });
      return;
    }

    const comparisonResult = await compareAds(ad1, ad2, token);
    const result = comparisonResult
      ? 'The ads are identical'
      : 'The ads are different';

    const logFirstAd = await reportAd(ad1, token);
    const logSecondAd = await reportAd(ad2, token);

    this.setState({ result, logFirstAd, logSecondAd });
  };

  render() {
    const { firstAd, secondAd } = this.state.form;
    const { result, logFirstAd, logSecondAd } = this.state;

    return (
      <div className="compare-ads-container">
        <Form.Input
          placeholder="First Ad"
          type="text"
          name="firstAd"
          value={firstAd}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <Form.Input
          placeholder="Second Ad"
          type="text"
          name="secondAd"
          value={secondAd}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <Button onClick={this.handleCompareAds} size="small" color="blue">
          Compare
        </Button>
        <Divider hidden />
        {result ? (
          <div className="compare-ads-message">
            <label>{result}</label>
          </div>
        ) : null}
        <div className="compare-ads-logs-container">
          <div className="compare-ads-log">
            <TextArea
              className="debug-log"
              placeholder="Log First Ad"
              disabled
              rows="30"
              value={logFirstAd}
            />
          </div>
          <div className="compare-ads-log">
            <TextArea
              className="debug-log"
              placeholder="Log Second Ad"
              disabled
              rows="30"
              value={logSecondAd}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CompareAds;



// WEBPACK FOOTER //
// ./src/screens/AdComparer/CompareAds.js